<template>
    <div class="layout default">
        <nav class="header">
            <app-header/>
        </nav>

        <main class="content">
            <slot/>
        </main>

        <footer class="footer">
            <app-footer/>
        </footer>
    </div>
</template>

<script>
import AppHeader from '../components/Header';
import AppFooter from '../components/Footer';
import Splash from '../views/Splash';
import UserBannedModalHandler from "../components/UserBannedModalHandler";

export default {
    components: {
        UserBannedModalHandler,
        AppHeader,
        AppFooter,
        Splash,
    },
}
</script>

<style scoped lang="scss">
@import './../styles/variables';
.container{
    max-width: 960px;
}
</style>

<style lang="scss">
.container{
    max-width: 960px;
    .top{
        background: #000000;
    }
}
</style>
